import {ProjectService, TemplateProject, TemplateProjectTask} from './../../general/project.service';
import {Component, EventEmitter, Input, OnInit, Output, inject} from '@angular/core';
import {TaskGroupIdsEnum, TaskService} from '../task.service';
import {Router} from '@angular/router';
import {AuthService} from 'src/app/services';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: 'app-template-project-task-popup',
    templateUrl: './template-project-task-popup.component.html',
    styleUrls: ['./template-project-task-popup.component.scss'],
    standalone: false
})
export class TemplateProjectTaskPopupComponent implements OnInit {
	@Input() show: boolean;
	@Input() isEditPopup: boolean;
	@Input() isMinified: boolean;

	@Input() currentUrl = '';
	@Input() taskId: number;
	@Input() parentTemplateTaskId: number;
	@Input() taskName: string;
	@Input() taskDescription: string;
	@Input() responsibleUser: string;
	@Input() startDate: Date | number | string;
	@Input() deadlineDate: Date | number | string;
	@Input() priority: string;
	@Input() allowReminder: boolean;
	@Input() link: string;
	@Input() solutionDescription: string;
	@Input() status: string;
	@Input() taskGroup1: string;
	@Input() taskGroup2: string;
	@Input() progress: number;
	@Input() projectId: number;
	@Input() newIdToReplaceAutogeneratedGUID: number;

	@Input() templateProject: TemplateProject;
	@Input() templateTasks: TemplateProjectTask[];
	public parentTasks: TemplateProjectTask[] = [];

	@Output() showChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	@Output() onSubmitted: EventEmitter<TemplateProjectTask> = new EventEmitter<TemplateProjectTask>();

	task: TemplateProjectTask = new TemplateProjectTask();
	now = new Date();
	deadlineDefault = new Date();
	title = 'Create new Task';
	taskPriorities: string[] = [];
	taskStatuses: string[] = [];
	taskGroupValues1: string[] = [];
	taskGroupValues2: string[] = [];
	userNames: string[] = [];

	public projects: TemplateProject[];

	
	private _notificationService: NotificationService = inject(NotificationService);

	constructor(
		private taskService: TaskService,
		private router: Router,
		private authService: AuthService,
		private projectService: ProjectService
	) {}

	ngOnInit() {
		if (this.isEditPopup) {
			this.title = 'Edit Task';
		}

		this.taskService.getTaskPriorities().subscribe((result) => {
			result.forEach((element) => {
				this.taskPriorities.push(element.listElement);

				if (!this.priority && element.isDefault) {
					this.priority = element.listElement;
				}
			});
		});
		this.taskService.getTaskStatuses().subscribe((result) => {
			result.forEach((element) => {
				this.taskStatuses.push(element.listElement);

				if (!this.status && element.isDefault) {
					this.status = element.listElement;
				}
			});
		});
		this.taskService.getTaskGroups().subscribe((result) => {
			result.forEach((element) => {
				if (element.listId === TaskGroupIdsEnum.TaskGroup1) {
					this.taskGroupValues1.push(element.listElement);

					if (!this.taskGroup1 && element.isDefault) {
						this.taskGroup1 = element.listElement;
					}
				}
				if (element.listId === TaskGroupIdsEnum.TaskGroup2) {
					this.taskGroupValues2.push(element.listElement);

					if (!this.taskGroup2 && element.isDefault) {
						this.taskGroup2 = element.listElement;
					}
				}
			});
		});
		this.taskService.getUserList().subscribe((result) => {
			result.forEach((element) => {
				this.userNames.push(element);
			});
		});

		this.projectService.getTemplateProjects().subscribe((result) => {
			this.projects = result;
		});

		this.updateCollections();

		if (!this.startDate) {
			this.startDate = this.now;
		}

		this.deadlineDefault.setDate(this.deadlineDefault.getDate() + 7);

		if (!this.deadlineDate) {
			this.deadlineDate = this.deadlineDefault;
		}

		if (!this.responsibleUser) {
			this.responsibleUser = this.authService.currentUserName;
		}
	}

	public setDefaultValuesIfNone() {
		if (!this.priority && this.taskPriorities.length > 0) {
			this.priority = this.taskPriorities[0];
		}

		if (!this.status && this.taskStatuses.length > 0) {
			this.status = this.taskStatuses[0];
		}

		if (!this.taskGroup1 && this.taskGroupValues1.length > 0) {
			this.taskGroup1 = this.taskGroupValues1[0];
		}

		if (!this.taskGroup2 && this.taskGroupValues2.length > 0) {
			this.taskGroup2 = this.taskGroupValues2[0];
		}

		if (!this.startDate) {
			this.startDate = this.now;
		}

		if (!this.deadlineDate) {
			this.deadlineDate = this.deadlineDefault;
		}

		if (!this.responsibleUser) {
			this.responsibleUser = this.authService.currentUserName;
		}
	}

	public updateCollections() {
		


		if (this.projectId) {
			this.parentTasks = this.templateTasks.filter((task) => task.templateProjectId === this.projectId && !task.isActive);
		} else {
			this.parentTasks = [...this.templateTasks].filter((task) => !task.isActive);
		}
	}

	public onShown(event: any) {
		this.updateCollections();
	}

	cancelTask() {
		this.show = false;
	}

	changePopupStatus() {
		this.showChange.emit(this.show);
	}

	goToLink() {
		if (this.link.indexOf('?') > -1) {
			this.link += '&taskid=' + this.taskId;
		} else {
			this.link += '?taskid=' + this.taskId;
		}

		this.router.navigateByUrl(this.link).then(() => {});
	}


	onTaskFormSubmit(e) {
	
		this.task.id = this.taskId;
		this.task.parentTemplateTaskId = this.parentTemplateTaskId;
		this.task.templateTaskName = this.taskName;
		this.task.templateTaskDescription = this.taskDescription;
		this.task.responsibleUser = this.responsibleUser;
		this.task.startDate = this.startDate;
		this.task.deadlineDate = this.deadlineDate;
		this.task.priority = this.priority;
		this.task.allowReminder = this.allowReminder;
		this.task.solutionDescription = this.solutionDescription;
		this.task.link = this.isEditPopup ? this.link : this.currentUrl;
		this.task.taskGroup1 = this.taskGroup1;
		this.task.taskGroup2 = this.taskGroup2;
		this.task.progress = this.progress;
		this.task.templateProjectId = this.projectId;
		this.task.newIdToReplaceAutogeneratedGUID = this.newIdToReplaceAutogeneratedGUID;

		this.onSubmitted.emit(this.task);

		if (!this.isEditPopup) {
			this.task.prepareForCreation(this.templateProject);

			this.projectService.createTemplateProjectTask(
				this.task,
				{
					showLoadingIndicator: true,

				}
			).subscribe(
				{
					next: (_) => {
						this.task = new TemplateProjectTask();

						this._notificationService.success('Task added successfully.');



						this.show = false;
					}
				}
			);
		} else {
			this.task.id = this.taskId;

			this.task.prepareForUpdate(this.templateProject, this.templateTasks);

			this.projectService.updateTemplateProjectTask(
				this.task,
				{
					showLoadingIndicator: true,
				}
			).subscribe(
				{
					next: (_) => {
						this.task = new TemplateProjectTask();

						this._notificationService.success('Task updated successfully.');



						this.show = false;
					}
				}
			);
		}
	}

	changeInfoPopupStatusTask() {

	}

	public progressFormat(value: any) {
		return value + '%';
	}


	public onStatusValueChanged(event: any) {
		console.log('onStatusValueChanged - event:', event);

		if (event.value) {
			if (event.value.trim().toLowerCase() === 'done') {
				this.progress = 100;
			} else if (event.value.trim().toLowerCase() === 'in progress' && event.previousValue.trim().toLowerCase() === 'done') {
				this.progress = 50;
			}
		}
	}
}
